import type { BillingBlockPayload } from '../types';

export interface BillingBlockedContext {
  projectId?: string;
  capability?: string;
  actionLabel?: string;
  returnTo?: string;
}

export class BillingBlockedError extends Error {
  readonly status = 402;
  readonly billingBlock: BillingBlockPayload;
  readonly payload: Record<string, unknown>;

  constructor(message: string, billingBlock: BillingBlockPayload, payload: Record<string, unknown> = {}) {
    super(message);
    this.name = 'BillingBlockedError';
    this.billingBlock = billingBlock;
    this.payload = payload;
  }
}

export function parseBillingBlockedPayload(
  status: number,
  payload: Record<string, unknown> | undefined,
): BillingBlockedError | null {
  if (status !== 402 || !payload) return null;
  const block = payload.billingBlock as BillingBlockPayload | undefined;
  if (!block?.type) return null;
  return new BillingBlockedError(
    String(payload.error || 'Billing access required'),
    block,
    payload,
  );
}

export function emitBillingBlocked(
  billingBlock: BillingBlockPayload,
  context: BillingBlockedContext = {},
): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('segmently:billing-blocked', {
    detail: { billingBlock, context },
  }));
}

export function notifyBillingBlockedError(
  error: unknown,
  context: BillingBlockedContext = {},
): boolean {
  if (error instanceof BillingBlockedError) {
    emitBillingBlocked(error.billingBlock, context);
    return true;
  }
  return false;
}
